<template>
    <checkout-step step-num="2" :step="step" stepName="Card Message and Special Instructions" @continue="validate" @edit="$emit('edit')">
        <div slot="active">

            <b-field :message="errors.first('card_message')" label="Card Message">
                <b-input maxlength="350" type="textarea" placeholder="Is there anything special you would like us to write on the card?" name="card_message" v-model.trim="data.card_message" v-validate="{max: 350}"></b-input>
            </b-field>
            <b-field :message="errors.first('special_instructions')" label="Special Instructions">
                <b-input maxlength="255" type="textarea" placeholder="Is there anything we should know about this order?" name="special_instructions" v-model="data.special_instructions" v-validate="{max: 255}"></b-input>
            </b-field>
        </div>
        <div slot="finished">
            <p>{{ data.card_message }}</p>
            <p>{{ data.special_instructions }}</p>
        </div>
    </checkout-step>
</template>

<script>
import CheckoutStep from '../CheckoutStep';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker';
import BField from 'buefy/src/components/field/Field';
import BInput from 'buefy/src/components/input/Input';
import { parse, asYouType } from 'libphonenumber-js';

export default {
  components: {
    BInput,
    BField,
    BDatepicker,
    CheckoutStep,
  },

  data() {
    const today = new Date();

    return {
      date: new Date(),
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),

//      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14),
      maxDate: new Date(today.getFullYear(), today.getMonth() + 2, today.getDate()),

    };
  },

  name: 'checkout-step2',

  props: ['data', 'step'],

  methods: {
    validate() {
      this.$validator.validateAll().then((valid) => {
        if (valid) this.$emit('valid');
      });
    },
  },

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout-steps/CheckoutStep2.vue